import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import axios from 'axios';
import { read, utils, writeFile } from 'xlsx';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Backdrop,
  CircularProgress,
  Select,
  MenuItem
} from '@material-ui/core';
import Controls from '../controls/Controls';
import { useSettingContext } from '../../context/setting_context';
import { baseUrl, services, departments, tierSchemes, memberTypes } from '../../utils/constants';
import LimitsMgmtSub from './LimitsMgmtSub';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const LimitsMgmt = () => {
  const { limitSetup, setLimitSetUp, clearLimits } = useSettingContext();
  const m = moment();
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTarrifs, setShowTarrifs] = useState(false);
  const [principalSchemeID, setSchemeId] = useState(1);
  const [memberTypeID, setMemberType] = useState(1);
  const [serviceTypeId, setServiceType] = useState(1);
  const [departmentId, setDepartmentId] = useState(1);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const classes = useStyles();

  const processSearch = async () => {
    setLoading(true);
    console.log('principalSchemeID', principalSchemeID, memberTypeID, serviceTypeId, departmentId);

    await axios(
      `${baseUrl}/api/setting/searchSchemeServiceBenefit?principalSchemeID=${principalSchemeID}&memberTypeID=${memberTypeID}&serviceTypeId=${serviceTypeId}&departmentId=${departmentId}`
    ).then(
      (result) => {
        setLoading(false);
        console.log('returned Limit info', result);
        if (result.data === '') {
          setShowTarrifs(false);
          notifyPopup(`No Benefit Setting of Selection Exists`, 'error');
        } else {
          setShowTarrifs(true);
          setLimitSetUp(result.data);
        }
      },
      (error) => {
        notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
      }
    );
  };

  const addNew = async () => {
    clearLimits();
    setShowTarrifs(true);
    setSchemeId('');
    setServiceType('');
    setMemberType('');
    setDepartmentId('');
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Card>
      <CardContent>
        <Box>
          <div className="col-sm-6 offset-3">
            <div className="row">
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography component="span" variant="h4" gutterBottom>
                Mantain Limits
              </Typography>
              <Grid container spacing={2} mb={2} ml={2} alignItems="center">
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="tierLabel">Tier Scheme</InputLabel>
                    <Select
                      id="principalSchemeID"
                      value={principalSchemeID}
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => setSchemeId(e.target.value)}
                    >
                      <MenuItem key="" value="">
                        Not Selected
                      </MenuItem>
                      {tierSchemes.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="memberTypeLabel">Member Type</InputLabel>
                    <Select
                      id="memberTypeID"
                      value={memberTypeID}
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => setMemberType(e.target.value)}
                    >
                      {memberTypes.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="service_Type_IdTxt">Service Type</InputLabel>
                    <Select
                      id="serviceTypeId"
                      value={serviceTypeId}
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => setServiceType(e.target.value)}
                    >
                      <MenuItem key="" value="">
                        Not Selected
                      </MenuItem>
                      {services.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <FormControl fullWidth>
                    <InputLabel id="department_idTxt">Department</InputLabel>
                    <Select
                      id="departmentId"
                      value={departmentId}
                      fullWidth
                      size="small"
                      variant="outlined"
                      onChange={(e) => setDepartmentId(e.target.value)}
                    >
                      <MenuItem key="" value="">
                        Not Selected
                      </MenuItem>
                      {departments.map((item) => (
                        <MenuItem key={item.refId} value={item.refId}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={1} ml={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<SearchIcon />}
                    onClick={() => processSearch()}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={12} sm={1} ml={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() => addNew()}
                  >
                    New
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </Box>

        {showTarrifs && <LimitsMgmtSub />}
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </CardContent>
    </Card>
  );
};

export default LimitsMgmt;
